import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default function usePageView() {
  const location = useLocation();

  useEffect(() => {
    console.log("Page view event triggered");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: `${location.pathname}${location.search}`,
      title: document.title,
    });
  }, [location]);
}
